<div class="center-small-container">

  <h1 class="page-title-center">Password change</h1>

  <form
    class="account-update-form gap-15"
    [formGroup]="passwordForm"
    (ngSubmit)="updatePassword()"
    >
    <mat-form-field appearance="outline">
      <mat-label>Current password</mat-label>
      <input
        matInput
        [type]="hideCurrent() ? 'password' : 'text'"
        formControlName="password"
        placeholder="Enter your current password"
        />
      <button
        class="mr-7"
        mat-button
        matSuffix
        (click)="hideCurrent.set(!hideCurrent())"
        type="button"
        >
        {{ hideCurrent() ? "Show" : "Hide" }}
      </button>
      @if (passwordForm.get('password')?.invalid) {
        <mat-error
          >Current password is required</mat-error
          >
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>New password</mat-label>
        <input
          matInput
          [type]="hideNew() ? 'password' : 'text'"
          formControlName="new_password"
          placeholder="Enter your new password"
          />
        <button
          class="mr-7"
          mat-button
          matSuffix
          (click)="hideNew.set(!hideNew())"
          type="button"
          >
          {{ hideNew() ? "Show" : "Hide" }}
        </button>
        @if (passwordForm.get('new_password')?.invalid) {
          <mat-error
            >New password is too short</mat-error
            >
          }
        </mat-form-field>

        <button
          mat-flat-button
          class="mat-button-squared-full-width"
          type="submit"
          matTooltip="Update"
          [disabled]="passwordForm.invalid"
          >
          Update
        </button>

      </form>

      <br />

      <div class="bottom-actions">
        <button mat-button (click)="goBack()" matTooltip="Go back">
          Go back
        </button>
      </div>

    </div>


